import { usersService } from "./users.service";
import { authService } from "./auth.service";

function normalizeSessionData(legacyUserData = {}, authSession = {}) {
  return {
    ...legacyUserData,
    licenseeId: authSession?.licenseeId ?? authSession?.LicenseeId ?? legacyUserData?.licenseeId ?? legacyUserData?.LicenseeId ?? "",
    userId: authSession?.userId ?? authSession?.UserId ?? legacyUserData?.userId ?? legacyUserData?.UserId ?? "",
    userName: authSession?.userName ?? authSession?.UserName ?? legacyUserData?.userName ?? legacyUserData?.UserName ?? "",
    userLogId: authSession?.userLogId ?? authSession?.UserLogId ?? legacyUserData?.userLogId ?? legacyUserData?.UserLogId ?? "",
    userLogName: authSession?.userLogName ?? authSession?.UserLogName ?? legacyUserData?.userLogName ?? legacyUserData?.UserLogName ?? "",
    regionalId: authSession?.regionalId ?? authSession?.RegionalId ?? legacyUserData?.regionalId ?? legacyUserData?.RegionalId ?? "",
    clientId: authSession?.clientId ?? authSession?.ClientId ?? legacyUserData?.clientId ?? legacyUserData?.ClientId ?? "",
    clientName: authSession?.clientName ?? authSession?.ClientName ?? legacyUserData?.clientName ?? legacyUserData?.ClientName ?? "",
    levelId: authSession?.levelId ?? authSession?.LevelId ?? legacyUserData?.levelId ?? legacyUserData?.LevelId ?? "",
    levelName: authSession?.levelName ?? authSession?.LevelName ?? legacyUserData?.levelName ?? legacyUserData?.LevelName ?? "",
    remoteIpAddress: authSession?.remoteIpAddress ?? authSession?.RemoteIpAddress ?? legacyUserData?.remoteIpAddress ?? legacyUserData?.RemoteIpAddress ?? "",
    languageId: authSession?.languageId ?? authSession?.LanguageId ?? legacyUserData?.languageId ?? legacyUserData?.LanguageId ?? "",
    commandPermission: authSession?.commandPermission ?? authSession?.CommandPermission ?? legacyUserData?.commandPermission ?? legacyUserData?.CommandPermission ?? "",
    editPermission: authSession?.editPermission ?? authSession?.EditPermission ?? legacyUserData?.editPermission ?? legacyUserData?.EditPermission ?? "",
  };
}

// Função para buscar dados do usuário (GET /api/v3/users)
async function users() {
  try {
    const [legacyUserData, authSession] = await Promise.all([
      usersService.users(),
      authService.fetchAuth(),
    ]);

    if (legacyUserData || authSession) {
      return normalizeSessionData(legacyUserData, authSession);
    }

    return null;
  } catch (error) {
    console.error("Erro ao buscar dados do usuário:", error);
    return null;
  }
}

// Função para atualizar dados do usuário (PUT /api/v3/users)
async function updateUsers(payload) {
  try {
    return await usersService.updateUser(payload);
  } catch (error) {
    console.error("Erro ao atualizar dados do usuário:", error);
    throw error;
  }
}

async function deletePhotoUser(photo) {
  try {
    // Implementar se necessário
    console.log("Função deletePhotoUser não implementada");
    return null;
  } catch (error) {
    console.error("Erro ao deletar foto do usuário:", error);
    throw error;
  }
}

export const profileService = {
  users,
  updateUsers,
  deletePhotoUser,
};
